import React, { useState, useEffect } from "react";
import styles from "./catalog.module.css";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import { SET_PATH_PARAMS } from "../../services/actions/path_params_actions";
import SwitcherCatProd from "../../components/switcher_cat_prod/switcher_cat_prod";
import { getDataFromCatalogRoutes, setMetaTags, deepFindBySlug } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import {
  getRoutes, getLoading, getProducts, getCategories
} from "../../services/selectors";
import Loader from "../../components/loader/loader";
import MenuContainer from "../../components/categories_menu/menu_container/menu_container";
import ProductsList from "../../components/products_list/products_list";



function Catalog() {

  let { slug1, slug2, slug3, slug4 } = useParams();
  const slugCategory = slug4 ? slug4 : slug3 ? slug3 : slug2 ? slug2 : slug1;

  const isLoading = useSelector(getLoading);
  const products = useSelector(getProducts);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [actualProducts, setActualProducts] = useState([]);
  const [checkProd, setCheckProd] = useState(true);

  const { categories } = useSelector(getCategories);
  const routes = useSelector(getRoutes);


  const {
    metaTitle
  } = getDataFromCatalogRoutes(location.pathname, navigate, routes, slug1);

  const [childrenCategories, setChildrenCategories] = useState(categories);


  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  useEffect(() => {

    dispatch({
      type: SET_PATH_PARAMS,
      uid: '',
      token: '',
      slug1: slug1 || '',
      slug2: slug2 || '',
      slug3: slug3 || '',
      slug4: slug4 || ''
    });
    // eslint-disable-next-line
  }, [location]);


  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, [metaTitle,]);

  const handleChecked = () => {
    setCheckProd(!checkProd);
  }


  useEffect(() => {
    if (location.pathname === '/catalog') {
      setChildrenCategories(categories);
      setActualProducts([...products.filter(product => product.category === null)]);
    } else {
      const includesCatalog = routes.some(route => route.path.includes('/catalog/'));
      const noCurrPath = !routes.find(r => r.path === location.pathname);
      if (
        includesCatalog && noCurrPath
      ) {
        navigate('/not-found', { replace: true });
        return;
      }
      const childrenCategories = deepFindBySlug(categories, slugCategory)
      if (childrenCategories && ('children' in childrenCategories) && Array.isArray(childrenCategories.children)) {
        setChildrenCategories(childrenCategories.children);
      }
      setActualProducts(
        [...products.filter(product => product.category === slugCategory)]
      );
    }
    if (childrenCategories.length) {
      setCheckProd(false);
    } else {
      setCheckProd(true);
    }
    // eslint-disable-next-line
  }, [childrenCategories, location.pathname, products, categories]);

  // рабочий вариант с new и sale
  //   useEffect(() => {
  //   if (
  //     routes.some(
  //       route => route.path.includes('/catalog/') &&
  //         route.path !== '/catalog/sale' &&
  //         route.path !== '/catalog/new'
  //     ) &&
  //     !isLoading &&
  //     !routes.find(r => r.path === location.pathname)
  //   ) {
  //     navigate('/not-found', { replace: true });
  //   }
  //   if (location.pathname === '/catalog') {
  //     setChildrenCategories(categories);
  //     setActualProducts([]);
  //     setCheckProd(false);
  //   } else if (location.pathname === '/catalog/sale') {
  //     setActualProducts(saleProducts);
  //     // setChildrenCategories([]);
  //     setCheckProd(true);
  //   } else if (location.pathname === '/catalog/new') {
  //     setActualProducts(newProducts);
  //     // setChildrenCategories([]);
  //     setCheckProd(true);
  //   } else {
  //     const childrenCats = deepFindBySlug(categories, slugCategory)
  //     if (childrenCats && ('children' in childrenCats) && Array.isArray(childrenCats.children)) {
  //       setChildrenCategories(childrenCats.children);
  //     } else {
  //       setChildrenCategories([]);
  //     }
  //     setActualProducts(
  //       [...products.filter(
  //         product => product.category === slugCategory && product.active
  //       )]
  //     );
  //     setCheckProd(actualProducts.length > 0 ? true : false);
  //   }

  //   // eslint-disable-next-line
  // }, [
  //   childrenCategories,
  //   location.pathname,
  //   products,
  //   categories
  // ]);


  return (
    <main className='main main__colons' >
      {isLoading && <Loader />}
      <MenuContainer />
      <div className="main_content">
        <SwitcherCatProd
          checkProd={checkProd}
          handleChecked={handleChecked}
          visible={childrenCategories.length > 0 && actualProducts.length > 0}
        />
        {checkProd === true && actualProducts.length > 0 &&
          <ProductsList actualProducts={actualProducts} />
        }
        {checkProd === false && childrenCategories.length > 0 &&


          <ul className={styles.list}>
            {childrenCategories.map((category) => {

              return (
                <li key={category.id}>
                  <Link to={category.path}
                    className={`${category.image ? styles.cardWithImage: styles.card}`}
                  >
                    {!!category.image &&
                      <img
                      alt={`Изображение категории "${category.name}"`} className={styles.img}
                      src={category.image}
                      />
                    }
                    <p className={`${category.image ? styles.categoryNameDown : styles.categoryName}`}>
                      {category.name}
                    </p>
                  </Link>
                </li>
              )
            })}
          </ul>
        }
      </div>

    </main>
  );

}
export default Catalog;
